import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import CustomText from "./CustomText";
import colors from "../constants/colors";

type LikedNameItemProps = {
  item: {
    id: string;
    nombre: string;
    sex: string;
    country: string;
  };
  drag: () => void;
  isActive: boolean;
  onDelete: (name: string) => void;
  onNavigate: (item: any) => void;
};

const countryLabels = [
  { label: "🇺🇸", value: "eeuu" },
  { label: "🇸🇪", value: "sweden" },
  { label: "🇪🇸", value: "spain" },
  { label: "🇮🇹", value: "italy" },
  { label: "🇬🇧", value: "uk" },
];

const getCountryFlag = (value: string): string => {
  const country = countryLabels.find((item) => item.value === value);
  return country ? country.label : "";
};

const LikedNameItem = React.memo(
  ({ item, drag, isActive, onDelete, onNavigate }: LikedNameItemProps) => {
    const sexSymbol = item.sex === "male" ? "♂" : "♀";
    const sexBackgroundColor =
      item.sex === "male" ? colors.maleBackground : colors.femaleBackground;
    const countryFlag = getCountryFlag(item.country);
    const sexSymbolColor =
      item.sex === "male" ? colors.maleSymbol : colors.femaleSymbol;

    return (
      <View style={[styles.row, isActive && styles.activeRow]}>
        <TouchableOpacity
          onLongPress={drag}
          delayLongPress={10}
          delayPressIn={50}
          style={styles.dragHandle}
          activeOpacity={0.7}
        >
          <Icon name="bars" size={20} color="#888" />
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.rowContent}
          onPress={() => onNavigate(item)}
        >
          <View
            style={[styles.infoGroup, { backgroundColor: sexBackgroundColor }]}
          >
            <View style={styles.infoContainer}>
              <CustomText style={styles.item}>{item.nombre}</CustomText>
            </View>
            <View style={styles.infoContainer}>
              <CustomText style={[styles.sexSymbol, { color: sexSymbolColor }]}>
                {sexSymbol}
              </CustomText>
            </View>
            <View style={styles.infoContainer}>
              <CustomText style={styles.country}>{countryFlag}</CustomText>
            </View>
          </View>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.iconButton}
          onPress={() => onDelete(item.nombre)}
        >
          <Icon name="trash" size={20} color="#000" />
        </TouchableOpacity>
      </View>
    );
  },
  (prevProps, nextProps) =>
    prevProps.item.id === nextProps.item.id &&
    prevProps.isActive === nextProps.isActive
);

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    backgroundColor: "#fff",
  },
  activeRow: {
    opacity: 0.8,
    borderLeftWidth: 3,
    borderLeftColor: "#007AFF",
  },
  dragHandle: {
    paddingHorizontal: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  rowContent: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 10,
  },
  infoGroup: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
    marginRight: 5,
  },
  infoContainer: {
    marginHorizontal: 5,
  },
  item: {
    fontSize: 18,
    color: "#000",
  },
  sexSymbol: {
    fontSize: 18,
    fontWeight: "bold",
  },
  country: {
    fontSize: 16,
    color: "#000",
  },
  iconButton: {
    padding: 5,
  },
});

export default LikedNameItem;
